import { getMinutesOfToday } from "components/CustomTimePicker/utils";
import { 
    HEADER_HEIGHT, 
    HEIGHT_CELL_BODY_WITH_MARGIN
} from "./constants";

export function getHours(startHour) {
    const timeList = [];
    let hour = startHour; 
    let minutes = 0;
    Array(24*4 - startHour*4)
        .fill(null)
        .forEach((_, idx) => {
            if (idx % 4 === 0) {
                hour = startHour + idx/4;
                minutes = 0;
            }
            else minutes += 15;
            timeList.push({
                hour, minutes,
                totalMinutes: hour*60 + minutes
            });
        });
    return timeList;
};
export function getPositionForTimeCursor(
    startHour,
    visualBlockMinutes = 60
) {
    const safeVisualBlockMinutes = visualBlockMinutes > 0
        ? visualBlockMinutes
        : 60;
    const startHourInPixels = (
        HEIGHT_CELL_BODY_WITH_MARGIN * startHour * 60
    ) / safeVisualBlockMinutes;
    const minutesOfToday = getMinutesOfToday();
    // Para testea el minutero, el formato es {hour}*60 + {minutes}
    // const minutesOfToday = 22*60 + 10;
    const timeInPixels = (
        HEIGHT_CELL_BODY_WITH_MARGIN * minutesOfToday
    ) / safeVisualBlockMinutes;
    return HEADER_HEIGHT + timeInPixels - startHourInPixels;
};

export function getQuantityCellsBySchedule({ timeStart, timeEnd }) {
	return (timeEnd - timeStart) / 15;
}
